import { atom } from 'jotai'
import { MovePayload } from 'pages/NestedCustomers/types'

export const formDataAtom = atom<MovePayload>()
formDataAtom.debugLabel = 'form-data'

export const transferErrorAtom = atom<string>()
transferErrorAtom.debugLabel = 'transfer-error'

export const apiErrorsAtom = atom<Array<{ parameter: string; message: string }>>([])
apiErrorsAtom.debugLabel = 'api-errors'
